import api from './api';

const API_URL = '/time-record';

export const findEmployeeByDocument = async (document) => {
  try {
    const response = await api.get(`${API_URL}/employee/${document}`);
    return response.data;
  } catch (error) {
    const apiMessage = error?.response?.data?.message;
    const message =
      typeof apiMessage === 'string'
        ? apiMessage
        : Array.isArray(apiMessage)
          ? apiMessage.join(', ')
          : 'No se encontró un funcionario con ese documento';
    throw new Error(message);
  }
};

export const markTimeRecord = async (data) => {
  const response = await api.post(`${API_URL}/mark`, data);
  return response.data;
};

export const getTimeRecords = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.employeeId) params.append('employeeId', filters.employeeId);
  if (filters.recordType) params.append('recordType', filters.recordType);
  const qs = params.toString();
  const url = qs ? `${API_URL}?${qs}` : API_URL;
  const response = await api.get(url);
  return response.data;
};

export const getTimeRecordSummary = async (filters) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.employeeId) params.append('employeeId', filters.employeeId);
  const response = await api.get(`${API_URL}/summary?${params.toString()}`);
  return response.data;
};

export const exportTimeRecords = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.employeeId) params.append('employeeId', filters.employeeId);
  if (filters.recordType) params.append('recordType', filters.recordType);
  const response = await api.get(`${API_URL}/export?${params.toString()}`);
  return response.data;
};

export const deleteTimeRecord = async (id) => {
  const response = await api.delete(`${API_URL}/${id}`);
  return response.data;
};
